import Add from '@mui/icons-material/AddCircleOutline';
import Cancel from '@mui/icons-material/Block';
import Clear from '@mui/icons-material/Clear';
import Close from '@mui/icons-material/Close';
import Db from '@mui/icons-material/Dns';
import DbOutline from '@mui/icons-material/DnsOutlined';
import Delete from '@mui/icons-material/Delete';
import Download from '@mui/icons-material/Download';
import Edit from '@mui/icons-material/Edit';
import Email from '@mui/icons-material/Email';
import Help from '@mui/icons-material/Help';
import HelpOutline from '@mui/icons-material/HelpOutline';
import Left from '@mui/icons-material/ChevronLeft';
import Login from '@mui/icons-material/Login';
import Logout from '@mui/icons-material/Logout';
import More from '@mui/icons-material/MoreHoriz';
import Power from '@mui/icons-material/Power';
import PowerOutline from '@mui/icons-material/PowerOutlined';
import Reports from '@mui/icons-material/Assessment';
import ReportsOutline from '@mui/icons-material/AssessmentOutlined';
import Save from '@mui/icons-material/Save';
import Search from '@mui/icons-material/Search';
import Secret from '@mui/icons-material/Key';
import Settings from '@mui/icons-material/Settings';
import SettingsOutline from '@mui/icons-material/SettingsOutlined';
import Unchecked from '@mui/icons-material/RadioButtonUnchecked';
import Upload from '@mui/icons-material/Publish';
import User from '@mui/icons-material/AccountCircle';
import UserOutline from '@mui/icons-material/AccountCircleOutlined';
import Users from '@mui/icons-material/People';
import UsersOutline from '@mui/icons-material/PeopleOutlined';

const Icon = {
  Add,
  Cancel,
  Clear,
  Close,
  Db,
  DbOutline,
  Delete,
  Download,
  Edit,
  Email,
  Help,
  HelpOutline,
  Left,
  Login,
  Logout,
  More,
  Power,
  PowerOutline,
  Reports,
  ReportsOutline,
  Save,
  Search,
  Secret,
  Settings,
  SettingsOutline,
  Unchecked,
  Upload,
  User,
  UserOutline,
  Users,
  UsersOutline,
};
export default Icon;
